module.exports = __webpack_public_path__ + "static/media/delete.1b4ada14.svg";